import { useContext } from 'react'

import { TrackerContext } from 'src/providers/Tracker'

export const useTrackerContext = () => useContext(TrackerContext)
